import {
  GET_ROLES_LIST,
  GET_ROLES,
  ADD_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  UPDATE_ROLE_STATUS,
  GET_ROLE_DETAILS,
  GET_ROLES_PERMISSIONS,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const rolesSlice = createCrudSlice({
  name: "roles",
  urls: {
    getList: GET_ROLES,
    getDropdownList: GET_ROLES_LIST,
    add: ADD_ROLE,
    update: UPDATE_ROLE,
    delete: DELETE_ROLE,
    updateStatus: UPDATE_ROLE_STATUS,
    getDetails: GET_ROLE_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {
    getRolesPermissions: {
      url: GET_ROLES_PERMISSIONS,
      method: "get",
      stateKey: "permissions",
    },
  },
  initialState: {
    permissions: [],
    roleType :""
  },
});

// Export actions
export const { setFilter, resetFilters } = rolesSlice.actions;

// Export thunks
export const {
  getList: getRoles,
  getDropdownList: getRolesList,
  add: addRole,
  update: updateRole,
  delete: deleteRole,
  updateStatus: updateRoleStatus,
  getDetails: getRoleDetails,
  getRolesPermissions,
} = rolesSlice.thunks;

// Export reducer
export default rolesSlice.reducer;
